import axios from 'axios'
const API_URL = process.env.REACT_APP_BASE_API_URL

const GET_ALL_STARTUP_SHOWCASE = `${API_URL}/startup-showcases`
const GET_STARTUP_SHOWCASE = `${API_URL}/startup-showcase`

export const getAllStartupShowcase = (companyId: number) => {
  return axios.get(`${GET_ALL_STARTUP_SHOWCASE}`, {
    headers: {
      'x-company-id': companyId,
    },
    validateStatus(status) {
      return true
    },
  })
}

export const getStartupShowcase = (companyId: number, startupShowcaseId: string) => {
  return axios.get(`${GET_STARTUP_SHOWCASE}/${startupShowcaseId}`, {
    headers: {
      'x-company-id': companyId,
    },
    validateStatus(status) {
      return true
    },
  })
}
